import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';

/**
 * Contract for checking if an account is suspended.
 */
@ApiContract({ endpoint: Api.checkSuspension, httpMethod: HttpMethods.get })
export class ApiCheckSuspension {
  constructor() {}
}
